export default __webpack_public_path__ + "static/media/article5.48a9852b.png";